import { getProfile, closeWindow } from "./liff-init";
import { type BookingDraft, type SlotKey } from "./types";

const API_URL = (import.meta.env.VITE_BOOKING_API_URL as string | undefined)
  ?? "https://ttyuansen.gbox.tw/booking";
const SECRET = (import.meta.env.VITE_BOOKING_SECRET as string | undefined) ?? "";

/**
 * Send a booking through our backend relay.
 *
 * Architecture:
 *   LIFF -> POST https://ttyuansen.gbox.tw/booking -> openclaw sysadmin agent -> admin Telegram
 *
 * The LINE chat between user and bot stays clean — no booking dump messages.
 * User only sees the in-LIFF toast confirmation.
 */
export async function sendBooking(d: BookingDraft & { slot: SlotKey }): Promise<void> {
  const profile = getProfile();

  const payload = {
    type: "ttyuansen.booking.tour.v1",
    date: d.date,
    slot: d.slot,
    headcount: d.headcount,
    needs: d.needs,
    contactName: d.contactName,
    notes: d.notes,
    liffUserId: profile?.userId,
    liffDisplayName: profile?.displayName,
    submittedAt: new Date().toISOString(),
  };

  let resp: Response;
  try {
    resp = await fetch(API_URL, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        ...(SECRET ? { "x-booking-secret": SECRET } : {}),
      },
      body: JSON.stringify(payload),
    });
  } catch (err) {
    throw new Error(`網路問題,請稍後再試:${(err as Error).message}`);
  }

  if (!resp.ok) {
    let detail = `HTTP ${resp.status}`;
    try {
      const body = await resp.json();
      if (body?.error) detail = body.error;
    } catch { /* ignore */ }
    throw new Error(detail);
  }

  // Close LIFF after a short delay so the user sees the confirm toast
  setTimeout(() => { void closeWindow(); }, 1800);
}
